<form [formGroup]="formG1">

	<div
		*ngFor="let myInput of myInputs"
		style="display: flex; flex-flow: row wrap; gap: .5em; align-items: stretch;"
	>

		<triv-input 
			[fGroup]="formG1" 
			[data]="myInput"
		></triv-input>

		<span
			*ngIf="!userSuscribable[myInput.id]"
			class="material-icons"
			style="font-size: 20px; cursor: default"
			title="Gesperrt für normale Benutzer"
		>
			lock_outline
		</span>

	</div>

</form>